import React, {createContext, useContext, useState} from "react";

export const ModalIds = {
    REQUEST_INQUIRY: 'request-inquiry',
    FACILITY_EDIT: 'facility-edit',
    INSTALL_APP: 'install-app',
    ONLINE_REGISTRATION: "online-registration",
    VIEW_LIST_OF_OFFICES: "view-list-of-offices",
    IMAGE_CROPPER_MODAL: "image-cropper-modal",
    REVIEW_INQUIRY: "review-inquiry"
}

export const ModalContext = createContext({
    modalId: undefined,
    modalOption: undefined,
    setModalOption: () => {
    },
    handleClickOpen: () => {
    },
    handleClose: () => {
    }
})

export const ModalProvider = ({children}) => {
    const [modalId, setModalId] = useState(undefined);
    const [modalOption, setModalOption] = useState(undefined);

    const handleClickOpen = (modalId, option = undefined) => {
        setModalId(modalId);
        setModalOption(option);
    };

    const handleClose = () => {
        setModalId(undefined);
        setModalOption(undefined);
    };

    return (
        <ModalContext.Provider value={{modalOption, setModalOption, modalId, handleClickOpen, handleClose}}>
            {children}
        </ModalContext.Provider>
    )
}

export const useModal = () => useContext(ModalContext);